// extracted by mini-css-extract-plugin
export default {"messageBlock":"_2UYp","messageContainer":"_3Ffi","text":"_1V7j","icon":"_27ob"};